import script from "./SimulatorTemplateManagerPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SimulatorTemplateManagerPanel.vue?vue&type=script&setup=true&lang=js"

import "./SimulatorTemplateManagerPanel.vue?vue&type=style&index=0&id=76cacef2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76cacef2"]])

export default __exports__